import { apiClient } from '@/services/ApiClient.js'

export default {
  getWorkflowJobs(query = {}) {
    return apiClient
      .get('workflow-jobs', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getWorkflowJob(id) {
    return apiClient
      .get('workflow-jobs/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createWorkflowJob(workflow) {
    return apiClient
      .post('workflow-jobs', workflow)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateWorkflowJob(id, workflow) {
    return apiClient
      .patch('workflow-jobs/' + id, workflow)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrderWorkflows(id) {
    return apiClient
      .get('orders/' + id + '/workflow-jobs')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createOrderWorkflow(orderId, workflowId) {
    return apiClient
      .post('orders/' + orderId + '/workflow-jobs/' + workflowId + '/toggle')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
